// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: global-notification.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.globalnotification";

export enum GlobalNotificationType {
  TYPE_UNKNOWN = 0,
  SYSTEM_NOTIFICATION = 1,
  PRODUCT_ANNOUNCEMENT = 2,
  UNRECOGNIZED = -1,
}

export function globalNotificationTypeFromJSON(object: any): GlobalNotificationType {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return GlobalNotificationType.TYPE_UNKNOWN;
    case 1:
    case "SYSTEM_NOTIFICATION":
      return GlobalNotificationType.SYSTEM_NOTIFICATION;
    case 2:
    case "PRODUCT_ANNOUNCEMENT":
      return GlobalNotificationType.PRODUCT_ANNOUNCEMENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GlobalNotificationType.UNRECOGNIZED;
  }
}

export function globalNotificationTypeToJSON(object: GlobalNotificationType): string {
  switch (object) {
    case GlobalNotificationType.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case GlobalNotificationType.SYSTEM_NOTIFICATION:
      return "SYSTEM_NOTIFICATION";
    case GlobalNotificationType.PRODUCT_ANNOUNCEMENT:
      return "PRODUCT_ANNOUNCEMENT";
    case GlobalNotificationType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Category {
  CATEGORY_UNKNOWN = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function categoryFromJSON(object: any): Category {
  switch (object) {
    case 0:
    case "CATEGORY_UNKNOWN":
      return Category.CATEGORY_UNKNOWN;
    case 1:
    case "INFO":
      return Category.INFO;
    case 2:
    case "WARN":
      return Category.WARN;
    case 3:
    case "ERROR":
      return Category.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Category.UNRECOGNIZED;
  }
}

export function categoryToJSON(object: Category): string {
  switch (object) {
    case Category.CATEGORY_UNKNOWN:
      return "CATEGORY_UNKNOWN";
    case Category.INFO:
      return "INFO";
    case Category.WARN:
      return "WARN";
    case Category.ERROR:
      return "ERROR";
    case Category.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GlobalNotificationProto {
  id: string;
  message: string;
  type: GlobalNotificationType;
  category: Category;
  active: boolean;
  enabled: boolean;
  lastUpdatedByUser: string;
  link?: string | undefined;
  header: string;
  imageS3Key?: string | undefined;
  expiresAt?: number | undefined;
  updatedAt: number;
  createdAt: number;
}

export interface CreateGlobalNotificationRequestProto {
  message: string;
  type: GlobalNotificationType;
  category: Category;
  enabled: boolean;
  link?: string | undefined;
  header?: string | undefined;
  imageS3Key?: string | undefined;
  expiresAt?: number | undefined;
}

export interface ModifyGlobalNotificationRequestProto {
  id: string;
  enabled: boolean;
  expiresAt: number;
}

export interface GetAllGlobalNotificationResponseProto {
  globalNotificationProto: GlobalNotificationProto[];
}

export interface GetImageKeyResponseProto {
  key: string;
}

function createBaseGlobalNotificationProto(): GlobalNotificationProto {
  return {
    id: "",
    message: "",
    type: 0,
    category: 0,
    active: false,
    enabled: false,
    lastUpdatedByUser: "",
    link: undefined,
    header: "",
    imageS3Key: undefined,
    expiresAt: undefined,
    updatedAt: 0,
    createdAt: 0,
  };
}

export const GlobalNotificationProto = {
  encode(message: GlobalNotificationProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.category !== 0) {
      writer.uint32(32).int32(message.category);
    }
    if (message.active !== false) {
      writer.uint32(40).bool(message.active);
    }
    if (message.enabled !== false) {
      writer.uint32(48).bool(message.enabled);
    }
    if (message.lastUpdatedByUser !== "") {
      writer.uint32(58).string(message.lastUpdatedByUser);
    }
    if (message.link !== undefined) {
      writer.uint32(66).string(message.link);
    }
    if (message.header !== "") {
      writer.uint32(74).string(message.header);
    }
    if (message.imageS3Key !== undefined) {
      writer.uint32(82).string(message.imageS3Key);
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(88).int64(message.expiresAt);
    }
    if (message.updatedAt !== 0) {
      writer.uint32(96).int64(message.updatedAt);
    }
    if (message.createdAt !== 0) {
      writer.uint32(104).int64(message.createdAt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalNotificationProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalNotificationProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.active = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.lastUpdatedByUser = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.link = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.header = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.imageS3Key = reader.string();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.updatedAt = longToNumber(reader.int64() as Long);
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.createdAt = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalNotificationProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      type: isSet(object.type) ? globalNotificationTypeFromJSON(object.type) : 0,
      category: isSet(object.category) ? categoryFromJSON(object.category) : 0,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      lastUpdatedByUser: isSet(object.lastUpdatedByUser) ? globalThis.String(object.lastUpdatedByUser) : "",
      link: isSet(object.link) ? globalThis.String(object.link) : undefined,
      header: isSet(object.header) ? globalThis.String(object.header) : "",
      imageS3Key: isSet(object.imageS3Key) ? globalThis.String(object.imageS3Key) : undefined,
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : undefined,
      updatedAt: isSet(object.updatedAt) ? globalThis.Number(object.updatedAt) : 0,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
    };
  },

  toJSON(message: GlobalNotificationProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.type !== 0) {
      obj.type = globalNotificationTypeToJSON(message.type);
    }
    if (message.category !== 0) {
      obj.category = categoryToJSON(message.category);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.lastUpdatedByUser !== "") {
      obj.lastUpdatedByUser = message.lastUpdatedByUser;
    }
    if (message.link !== undefined) {
      obj.link = message.link;
    }
    if (message.header !== "") {
      obj.header = message.header;
    }
    if (message.imageS3Key !== undefined) {
      obj.imageS3Key = message.imageS3Key;
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    if (message.updatedAt !== 0) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalNotificationProto>, I>>(base?: I): GlobalNotificationProto {
    return GlobalNotificationProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalNotificationProto>, I>>(object: I): GlobalNotificationProto {
    const message = createBaseGlobalNotificationProto();
    message.id = object.id ?? "";
    message.message = object.message ?? "";
    message.type = object.type ?? 0;
    message.category = object.category ?? 0;
    message.active = object.active ?? false;
    message.enabled = object.enabled ?? false;
    message.lastUpdatedByUser = object.lastUpdatedByUser ?? "";
    message.link = object.link ?? undefined;
    message.header = object.header ?? "";
    message.imageS3Key = object.imageS3Key ?? undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    message.updatedAt = object.updatedAt ?? 0;
    message.createdAt = object.createdAt ?? 0;
    return message;
  },
};

function createBaseCreateGlobalNotificationRequestProto(): CreateGlobalNotificationRequestProto {
  return {
    message: "",
    type: 0,
    category: 0,
    enabled: false,
    link: undefined,
    header: undefined,
    imageS3Key: undefined,
    expiresAt: undefined,
  };
}

export const CreateGlobalNotificationRequestProto = {
  encode(message: CreateGlobalNotificationRequestProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.category !== 0) {
      writer.uint32(24).int32(message.category);
    }
    if (message.enabled !== false) {
      writer.uint32(32).bool(message.enabled);
    }
    if (message.link !== undefined) {
      writer.uint32(42).string(message.link);
    }
    if (message.header !== undefined) {
      writer.uint32(50).string(message.header);
    }
    if (message.imageS3Key !== undefined) {
      writer.uint32(58).string(message.imageS3Key);
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(64).int64(message.expiresAt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateGlobalNotificationRequestProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateGlobalNotificationRequestProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.link = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.header = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.imageS3Key = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateGlobalNotificationRequestProto {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      type: isSet(object.type) ? globalNotificationTypeFromJSON(object.type) : 0,
      category: isSet(object.category) ? categoryFromJSON(object.category) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      link: isSet(object.link) ? globalThis.String(object.link) : undefined,
      header: isSet(object.header) ? globalThis.String(object.header) : undefined,
      imageS3Key: isSet(object.imageS3Key) ? globalThis.String(object.imageS3Key) : undefined,
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : undefined,
    };
  },

  toJSON(message: CreateGlobalNotificationRequestProto): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.type !== 0) {
      obj.type = globalNotificationTypeToJSON(message.type);
    }
    if (message.category !== 0) {
      obj.category = categoryToJSON(message.category);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.link !== undefined) {
      obj.link = message.link;
    }
    if (message.header !== undefined) {
      obj.header = message.header;
    }
    if (message.imageS3Key !== undefined) {
      obj.imageS3Key = message.imageS3Key;
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateGlobalNotificationRequestProto>, I>>(
    base?: I,
  ): CreateGlobalNotificationRequestProto {
    return CreateGlobalNotificationRequestProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateGlobalNotificationRequestProto>, I>>(
    object: I,
  ): CreateGlobalNotificationRequestProto {
    const message = createBaseCreateGlobalNotificationRequestProto();
    message.message = object.message ?? "";
    message.type = object.type ?? 0;
    message.category = object.category ?? 0;
    message.enabled = object.enabled ?? false;
    message.link = object.link ?? undefined;
    message.header = object.header ?? undefined;
    message.imageS3Key = object.imageS3Key ?? undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    return message;
  },
};

function createBaseModifyGlobalNotificationRequestProto(): ModifyGlobalNotificationRequestProto {
  return { id: "", enabled: false, expiresAt: 0 };
}

export const ModifyGlobalNotificationRequestProto = {
  encode(message: ModifyGlobalNotificationRequestProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.enabled !== false) {
      writer.uint32(40).bool(message.enabled);
    }
    if (message.expiresAt !== 0) {
      writer.uint32(64).int64(message.expiresAt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ModifyGlobalNotificationRequestProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModifyGlobalNotificationRequestProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModifyGlobalNotificationRequestProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : 0,
    };
  },

  toJSON(message: ModifyGlobalNotificationRequestProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.expiresAt !== 0) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModifyGlobalNotificationRequestProto>, I>>(
    base?: I,
  ): ModifyGlobalNotificationRequestProto {
    return ModifyGlobalNotificationRequestProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModifyGlobalNotificationRequestProto>, I>>(
    object: I,
  ): ModifyGlobalNotificationRequestProto {
    const message = createBaseModifyGlobalNotificationRequestProto();
    message.id = object.id ?? "";
    message.enabled = object.enabled ?? false;
    message.expiresAt = object.expiresAt ?? 0;
    return message;
  },
};

function createBaseGetAllGlobalNotificationResponseProto(): GetAllGlobalNotificationResponseProto {
  return { globalNotificationProto: [] };
}

export const GetAllGlobalNotificationResponseProto = {
  encode(message: GetAllGlobalNotificationResponseProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.globalNotificationProto) {
      GlobalNotificationProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAllGlobalNotificationResponseProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllGlobalNotificationResponseProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.globalNotificationProto.push(GlobalNotificationProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllGlobalNotificationResponseProto {
    return {
      globalNotificationProto: globalThis.Array.isArray(object?.globalNotificationProto)
        ? object.globalNotificationProto.map((e: any) => GlobalNotificationProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAllGlobalNotificationResponseProto): unknown {
    const obj: any = {};
    if (message.globalNotificationProto?.length) {
      obj.globalNotificationProto = message.globalNotificationProto.map((e) => GlobalNotificationProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllGlobalNotificationResponseProto>, I>>(
    base?: I,
  ): GetAllGlobalNotificationResponseProto {
    return GetAllGlobalNotificationResponseProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllGlobalNotificationResponseProto>, I>>(
    object: I,
  ): GetAllGlobalNotificationResponseProto {
    const message = createBaseGetAllGlobalNotificationResponseProto();
    message.globalNotificationProto =
      object.globalNotificationProto?.map((e) => GlobalNotificationProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetImageKeyResponseProto(): GetImageKeyResponseProto {
  return { key: "" };
}

export const GetImageKeyResponseProto = {
  encode(message: GetImageKeyResponseProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetImageKeyResponseProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetImageKeyResponseProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetImageKeyResponseProto {
    return { key: isSet(object.key) ? globalThis.String(object.key) : "" };
  },

  toJSON(message: GetImageKeyResponseProto): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetImageKeyResponseProto>, I>>(base?: I): GetImageKeyResponseProto {
    return GetImageKeyResponseProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetImageKeyResponseProto>, I>>(object: I): GetImageKeyResponseProto {
    const message = createBaseGetImageKeyResponseProto();
    message.key = object.key ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
